import { useQuery } from '@tanstack/react-query';

import { analysisKeys } from '../../keys/analysis-keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseMeasureProps {
  measureId: number;
}
export function useMeasure(props: UseMeasureProps) {
  const query = useQuery({
    ...analysisKeys.measureDetail(props.measureId),
  });

  return query;
}

export default useMeasure;
